import {
  $orderIpnTypeName,
  $subscriptionIpnTypeNames,
} from "@/services/paypro-payment/paypro.data";
import { getUserSubscription } from "@/actions/db/user-subscription";

export const isFirstSubscriptionBuy = (ipnTypeName: string): boolean =>
  ipnTypeName === $orderIpnTypeName.orderCharged;

export const isOrderRefunded = (ipnTypeName: string): boolean =>
  ipnTypeName === $orderIpnTypeName.orderRefunded;

export const isOrderChargedBack = (ipnTypeName: string): boolean =>
  ipnTypeName === $orderIpnTypeName.orderChargedBack;

export const isSubscriptionContinued = (ipnTypeName: string): boolean =>
  ipnTypeName === $subscriptionIpnTypeNames.subscriptionChargeSucceed;

export const isSubscriptionPaymentFailed = (ipnTypeName: string): boolean =>
  ipnTypeName === $subscriptionIpnTypeNames.subscriptionChargeFailed;

export const isSubscriptionFinished = (ipnTypeName: string): boolean =>
  ipnTypeName === $subscriptionIpnTypeNames.subscriptionFinished;

export const isSubscriptionRenewed = (ipnTypeName: string): boolean =>
  ipnTypeName === $subscriptionIpnTypeNames.subscriptionRenewed;

export const isSubscriptionSuspended = (ipnTypeName: string): boolean =>
  ipnTypeName === $subscriptionIpnTypeNames.subscriptionSuspended;

export const isUserSubscriptionExpired = async (userId: string) => {
  const userSubscription = await getUserSubscription(userId);

  if (userSubscription === null || !userSubscription.cancelAt) {
    return true;
  }

  return userSubscription.cancelAt.getTime() < new Date().getTime();
};
